export default {
  default: {
    title: 'No Form Templates',
    paragraphOne: "You either haven't created any templates, or you need to adjust your filters to return more results.",
    paragraphTwo: "If you haven't started yet you can create one now from the button at the top of the page or from an existing Form.",
  },
}
